import { render, staticRenderFns } from "./RequestDetailConversation.vue?vue&type=template&id=998fbf7e"
import script from "./RequestDetailConversation.vue?vue&type=script&lang=js"
export * from "./RequestDetailConversation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports